import { styled } from "@mui/system";
import COLORS from "../../../theme/Colors";
import FONTS_FAMILY from "../../../theme/FontsFamily";

export const FooterContainer = styled("footer")({
  backgroundColor: "#1D2862",
  color: COLORS.white,
  width: "100%",
  padding: "20px 0 0 0",
  fontFamily: FONTS_FAMILY.regular.body,
});

export const MainContent = styled("div")({
  width: "85%",
  maxWidth: "1920px",
  margin: "0 auto",
  padding: "0 10px",
  display: "grid",
  gridTemplateColumns: "1.2fr auto 1fr 1fr 1fr 1fr",
  gap: "25px",
  "@media (max-width: 1024px)": {
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },
  "@media (max-width: 600px)": {
    gridTemplateColumns: "1fr 1fr",
    gap: "15px",
    padding: "0 10px",
  },
});

export const FooterColumn = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  textAlign: "left",
  "&:first-of-type": {
    "@media (max-width: 1024px)": {
      gridColumn: "span 2",
      alignItems: "center",
      marginBottom: "20px",
    },
  },
});

export const ColumnTitle = styled("h4")({
  fontFamily: FONTS_FAMILY.bold.title,
  fontSize: "16px",
  fontWeight: 700,
  textTransform: "uppercase",
  marginBottom: "4px",
  color: COLORS.white,
});

export const FooterLink = styled("a")({
  color: "#cbd5e1", // Light gray for links
  textDecoration: "none",
  fontSize: "14px",
  transition: "color 0.2s ease",
  cursor: "pointer",
  margin: "1px 0",
  "&:hover": {
    color: COLORS.white,
    textDecoration: "underline",
  },
});

export const FooterInfo = styled("p")({
  color: "#cbd5e1",
  fontSize: "14px",
  margin: "1px 0",
  lineHeight: "1.3",
  textAlign: "left",
});

export const LogosContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "25px",
  marginBottom: "10px",
  "@media (max-width: 1024px)": {
    justifyContent: "center",
  },
});

export const Image = styled("img")({
  height: "65px",
  width: "auto",
  objectFit: "contain",
});

export const Divider = styled("div")({
  width: "1px",
  height: "80px",
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  alignSelf: "center",
  "@media (max-width: 1024px)": {
    display: "none",
  },
});

export const BottomFooter = styled("div")({
  backgroundColor: "#FFFFFF",
  borderTop: "1px solid #e2e8f0",
  padding: "15px 0",
  marginTop: "40px",
  width: "100%",
});

export const BottomContainer = styled("div")({
  width: "85%",
  maxWidth: "1920px",
  margin: "0 auto",
  padding: "0 10px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "@media (max-width: 768px)": {
    flexDirection: "column",
    gap: "20px",
    textAlign: "center",
  },
});

export const Copyright = styled("span")({
  fontSize: "13px",
  color: "#1D2862",
  fontWeight: 500,
});

export const SocialSection = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "15px",
});

export const FollowUsText = styled("span")({
  fontSize: "13px",
  fontWeight: 700,
  color: COLORS.secondary,
  textTransform: "uppercase",
  fontFamily: FONTS_FAMILY.bold.title,
});

export const IconContainer = styled("div")({
  display: "flex",
  gap: "10px",
});

export const SocialIcon = styled("a")({
  color: "#1D2862",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.2s ease",
  textDecoration: "none",
  "& i": {
    fontSize: "20px",
  },
  "&:hover": {
    transform: "translateY(-3px)",
    opacity: 0.8,
  },
});

export const CertificationsContainer = styled("div")({
  display: "none", // Hidden as requested
});
